import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  dialogContainer: {
    padding: '32px',
    // position: 'relative',
    overflowY: 'auto',
  },
  btnCloseOutside: {
    position: 'absolute',
    top: '-30px',
    right: '-30px',
    width: '30px',
    height: '30px',
    fontSize: '40px',
    color: '#fff',
    cursor: 'pointer',
    background: 'transparent',
    outline: 'none',
    border: 'none',
    '&::before, &::after': {
      position: 'absolute',
      left: '15px',
      content: '""',
      height: '33px',
      width: '3px',
      backgroundColor: '#ffffff',
    },
    '&::before': {
      transform: 'rotate(45deg)',
    },
    '&::after': {
      transform: 'rotate(-45deg)',
    },
  },
  dialogTitle: {
    borderBottom: '3px solid #b9bebe',
    paddingBottom: '18.6px',
    color: '#000',
    fontSize: '30px',
    lineHeight: '45px',
    fontFamily: 'Noto Sans JP',
    marginTop: 0,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      borderBottom: 'solid 3px #cd0021',
      bottom: '-3px',
      width: '100px',
      [theme.breakpoints.down('sm')]: {
        width: '50px',
        borderBottom: 'solid 2px #cd0021',
        bottom: '-2px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeigth: '30px',
      letterSpacing: '0.28px',
      paddingBottom: '15px',
      borderBottom: '2px solid #b9bebe',
    },
  },
  dialogContent: {
    marginTop: '20px',
    fontSize: '16px',
    color: '#6f7878',
    letterSpacing: '0.05em',
    lineHeight: 1.5,
    wordWrap: 'break-word',
    fontWeight: 500,
    fontFamily: 'Noto Sans JP',
    [theme.breakpoints.down('sm')]: {
      marginTop: '17px',
      fontSize: '13px',
      lineHeigth: '21px',
      letterSpacing: '0.28px',
    },
  },
  dialogBtn: {
    paddingTop: '4.375em',
    paddingBottom: '0.62em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      paddingTop: '56px',
      paddingBottom: '12px',
    },

    '& button': {
      color: '#999999',
      border: '1px solid #999999',
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'center',
      fontWeight: 400,
      background: 'transparent',
      padding: '6px 25px',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        padding: '5px 22px',
        fontSize: '13px',
        lineHeight: '21px',
      },
    },

  },
}));

export default useStyles;
